import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { impressionsConfig } from '../impressions';

export const mediaViewerImpressionsConfig: StatsConfig & {
    name: string;
    tooltip: string;
} = {
    ...impressionsConfig,
    name: 'kpi.twitter.total_impressions_count', // Use "Total impressions" label in media viewer
    tooltip: 'kpi.twitter.tooltip_total_impressions_count', // Use matching tooltip
    id: 'impression_count', // Override to match API field name
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
